// extracted by mini-css-extract-plugin
module.exports = {"container":"RoutesContainer_container__3paAh"};